import { render, staticRenderFns } from "./FormBtns.vue?vue&type=template&id=5c994902"
import script from "./FormBtns.vue?vue&type=script&lang=js"
export * from "./FormBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports